module.exports = __webpack_public_path__ + "static/media/arrow_prev.baab45f0.svg";